import { Route, Routes } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { FuncionarioListWrapper } from './funcionarios-list/FuncionariosList'
import { FC } from 'react'
import { useT } from '_metronic/i18n/Metronici18n'
import { ProfissionalValoresListWrapper } from './profissional-valores-list/ProfissionalValoresList'

export const FuncionariosPage: FC = () => {
  const { t } = useT()
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Funcionarios',
      path: '/apps/funcionarios',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  return (
    <Routes>
      <Route
        path=''
        element={
          <>
            <PageTitle description={t('pagina.funcionario.descricao')}>Funcionários</PageTitle>
            <FuncionarioListWrapper />
          </>
        }
      />
      <Route
        path='financeiro/:id'
        element={
          <>
            <PageTitle breadcrumbs={breadCrumbs}>Valores</PageTitle>
            <ProfissionalValoresListWrapper />
          </>
        }
      />
    </Routes>
  )
}
